const UTM_KEY = "vip77_utm";
const UTM_PARAMS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];

// Call once when the app first loads. If the landing URL carries UTM params
// (an ad click always triggers a real page load, never just client-side
// routing), store them so a later conversion - a quick order or checkout,
// possibly several pages deep - can still be attributed to the campaign
// that brought the visitor in.
export function captureUtmFromUrl() {
  try {
    const params = new URLSearchParams(window.location.search);
    const utm = {};
    for (const key of UTM_PARAMS) {
      const value = params.get(key);
      if (value) utm[key] = value;
    }
    if (Object.keys(utm).length) {
      utm.landing_page = window.location.pathname;
      localStorage.setItem(UTM_KEY, JSON.stringify(utm));
    }
  } catch {}
}

export function getStoredUtm() {
  try {
    const raw = localStorage.getItem(UTM_KEY);
    if (!raw) return null;
    const utm = JSON.parse(raw);
    return utm && Object.keys(utm).length ? utm : null;
  } catch {
    return null;
  }
}
